import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ProcurementPage } from '@/features/procurement/pages/ProcurementPage'

const searchSchema = z.object({
  tab: z.enum(['suppliers', 'purchase-orders', 'receipts', 'invoices']).catch('suppliers'),
})

export const Route = createFileRoute('/_app/procurement/')({
  validateSearch: searchSchema,
  component: ProcurementPage,
})
